<template>
  <div class="bonusProduct">
    <div class="box-card">
      <div class="card-header clearfix">
        <span>换新福利</span>
      </div>
      <div class="box-content">
        <p>环保补助金{{product.bonus_price}}元</p>
        <p v-if="user.bonus.value" @click="LimitDiscounts">
          {{user.bonus.name}}
          <van-icon name="arrow" class="item-right"/>
        </p>
      </div>
    </div>
    <van-popup v-model="couponVisible" position="bottom" popup-transition="popup-fade">
      <div class="couponBox">
        <div class="popup-header">
          <span>我的可用卡券</span>
          <button @click="LimitDiscounts">取消</button>
        </div>
        <div class="couponList">
          <div
            v-for="item in bonus"
            :key="item.id"
            @click="selectCoupon(item)"
            :class="user.bonus.id==item.id?'active':''"
          >
            <div class="coupon-item">
              <div class="coupon-head">
                <h2>
                  <span>¥</span>
                  <span>{{item.value}}</span>
                </h2>
                <p v-if="item.amount>0">满{{item.amount}}元可用</p>
              </div>
              <div class="coupon-body">
                <h2>{{item.name}}</h2>
                <p>有效期至 {{item.end_at}}</p>
                <i class="iconfont icon-choose-full"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: ["product"],
  data() {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      couponVisible: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    account() {
      return this.$store.state.account.user;
    },
    bonus() {
      return this.$store.state.user.bonuslist;
    }
  },
  methods: {
    LimitDiscounts() {
      console.log(112)
      this.couponVisible = !this.couponVisible;
    },
    selectCoupon(item) {
      this.$store.commit("user/setBonus", item);
      this.couponVisible = !this.couponVisible;
    }
  }
};
</script>

<style scoped>
.bonusProduct {
  background: #fff;
  margin-top: 0.05rem;
}
.card-header {
  line-height: 0.4rem;
  height: 0.4rem;
  padding: 0 0.12rem;
}
.box-content {
  padding: 0 0.12rem 0rem 0.12rem;
}
.box-content p {
  color: #f9415d;
  position: relative;
  padding: 0.15rem 0.3rem;
  border-top: solid #efefef 1px;
}
.box-content p::before {
  display: inline-block;
  width: 0.23rem;
  height: 0.215rem;
  content: "";
  background: url(../../../assets/image/bonusTitleBg.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: 0.15rem;
  left: 0;
}
.box-content p .item-right {
  font-size: 0.18rem;
  position: absolute;
  right: 0;
  color: #999;
  /* top:0; */
}

.LimitDiscounts {
  margin: 0.1rem 0;
  background: #fff;
  padding: 0.1rem;
  display: flex;
}
.LimitDiscounts label {
  display: inline-block;
  width: 50%;
}
.LimitDiscounts .value {
  display: inline-block;
  width: 50%;
  text-align: right;
  color: #ff4747;
}
.LimitDiscounts .value span {
  font-size: 0.14rem;
}
.LimitDiscounts .value .icon-enter {
  color: #666;
}
.couponBox {
  width: 3.75rem;
  bottom: 0;
  
}
.popup-header {
  height: 0.4rem;
  line-height: 0.4rem;
  background: #f6f6f6;
  border-bottom: solid #efefef 1px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding: 0rem 0.1rem;
}
.popup-header button {
  position: absolute;
  top: 0rem;
  right: 0.1rem;
  border: none;
  border: 0;
  background: none;
  font-size: 0.14rem;
  height: 0.4rem;
  text-align: right;
  width: 1rem;
  color: #888;
}
.couponList {
  margin-top: 0rem;
  height: 4rem;
  overflow:scroll;
}
.coupon-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  height: 0.75rem;
  width: 3.5rem;
  background: linear-gradient(#f36e64, #ef493e);
  margin: 0.1rem auto;
  position: relative;
  border-radius: 5px;
}

.coupon-head {
  color: #fff;
  line-height: 1;
  min-width: 1rem;
  text-align: left;
  margin: 0.15rem 0.1rem 0.1rem 0.2rem;
  border-right: solid #fff 1px;
}

.coupon-head h2 {
  font-size: 0.2rem;
  font-weight: normal;
  margin: 0 0 10px;
}

.coupon-head .h2 text {
  font-size: 24rpx;
  margin-left: 5rpx;
}

.coupon-head text {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.coupon-body {
  color: #fff;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  padding: 0 12px;
  overflow: hidden;
  position: relative;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-radius: 0 4px 4px 0;
}

.coupon-body h2 {
  margin: 0;
  opacity: 0.8;
  font-size: 16px;
  font-weight: normal;
}

.coupon-body p {
  font-size: 12px;
  margin: 5px 0 0;
}

.coupon-body p,
.coupon-body h2 {
  line-height: 1.4;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.coupon-body .icon-choose-full {
  display: block;
  position: absolute;
  right:.2rem;
  color:#000;
}
.coupon-body .icon-choose-full {
  display: none;
}
.active .coupon-body .icon-choose-full {
  display: block;
}
.coupon-btn {
  position: relative;
  padding: 0 10rpx 0 0;
}
</style>
